import Box from "@mui/material/Box";
import SignInPanel from "./components/SignInPanel/SignInPanel";
import { MultiFactorError } from "firebase/auth";
import OutputError from "config/OutputError";

function Login(props: {
  setError(error: null | OutputError | MultiFactorError): void;
  error: null | OutputError | MultiFactorError;
}) {
  return (
    <Box sx={{ bgcolor: "primary.main" }}>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <SignInPanel error={props.error} setError={props.setError} />
      </Box>
    </Box>
  );
}
export default Login;
